import { Route, Routes } from 'react-router-dom';

import { NotFound, Terms } from 'pages';

import styles from './App.module.css';

const App = () => (
  <div className={styles.root}>
    <Routes>
      <Route path="/:locale/merchant/:id" element={<Terms />} />
      <Route path="/:locale" element={<Terms />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  </div>
);

export default App;
